import type { SagaIterator } from 'redux-saga'
import { call, select, takeLatest } from 'redux-saga/effects'

import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import { Workspace } from '../../lib/toolBoxes/2D'
import { selectSelectedItem, updateSelectedPaperId } from '../../slices/2D'
import { GeometricDrawable, selectAllGeometricDrawables } from '../../slices/geometry'

export function* handleLockCanvasElements(): SagaIterator<void> {
    const manager: PaperManager | null = yield call(managers.get2DManager)

    if (!manager) return

    const [workspaceTool]: [Workspace] = yield call(manager.getTools, [Workspace.NAME])

    const selectedElementPaperId = yield select(selectSelectedItem)

    if (!selectedElementPaperId) {
        yield call(workspaceTool.lockItems, false)

        return
    }

    const items: paper.Item[] = yield call(workspaceTool.getItemsWithCriteria, 'id', (id) => {
        return id === selectedElementPaperId
    })
    const openingGroupId: number | null | undefined = items?.[0]?.data?.opening_group_id

    if (openingGroupId == null) return

    const drawables: GeometricDrawable[] = yield select(selectAllGeometricDrawables)
    const groupDrawableIds = drawables.reduce<number[]>((ids, drawable) => {
        if (drawable.opening_group_id === openingGroupId) ids.push(drawable.id)

        return ids
    }, [])

    // An empty exclusion list would lock the entire canvas while group data is unavailable.
    if (groupDrawableIds.length === 0) return

    yield call(workspaceTool.lockItems, true, groupDrawableIds)
}

export function* watchForCanvasElementsLocking() {
    yield takeLatest(updateSelectedPaperId.type, handleLockCanvasElements)
}
